// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"tooltip_tooltip__1VsHx","name":"tooltip_name__2xH9V","info":"tooltip_info__3Q_sr","moreInfo":"tooltip_moreInfo__rqQ-R"};